var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipseInProgressGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5.98438,
    r: 4.75,
    fill: "white",
    stroke: "#14BF86",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99973 11.0003C3.67366 10.9961 2.40356 10.4653 1.46884 9.52468C0.534116 8.58405 0.0113464 7.31062 0.015529 5.98455C0.0197116 4.65847 0.550504 3.38837 1.49114 2.45365C2.43177 1.51893 3.7052 0.99616 5.03127 1.00034L5.0155 6.00032L4.99973 11.0003Z",
    fill: "#14BF86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseInProgressGreen);
export default __webpack_public_path__ + "static/media/ellipse-in-progress-green.c7a22a335d16c4f6ac307f4d71c470b1.svg";
export { ForwardRef as ReactComponent };